/**
 * S1428 — les salariés qu'un contrat couvre (à l'écran : « Salariés couverts ») : « Tous les salariés »,
 * « Cadres seulement », ou « Autre » avec une précision courte.
 *
 * INFORMATIF SEULEMENT : aucune règle d'éligibilité ne la lit. Les DNS ne
 * disent pas qui est cadre ; l'accueil ne peut donc rien en déduire.
 * Distincte de `populationLibelle`, le libellé libre qui distingue deux
 * contrats sur la même offre (CP-08) : celui-là reste ce qu'il était.
 */
export const POPULATIONS_COUVERTES = ['TOUS_SALARIES', 'CADRES', 'AUTRE'];
export const LIBELLE_POPULATION_COUVERTE = {
    TOUS_SALARIES: 'Tous les salariés',
    CADRES: 'Cadres seulement',
    AUTRE: 'Autre',
};
/** Ce qu'on lit pour un contrat d'avant S1428, que personne n'a encore renseigné. */
export const POPULATION_NON_RENSEIGNEE = 'Non renseigné';
/** La précision d'« Autre » : un libellé, pas un paragraphe. */
export const PRECISION_POPULATION_MAX = 60;
/** « Cadres seulement », « Autre : ouvriers du site » ou « Non renseigné ». */
export function libellePopulationCouverte(population, precision) {
    if (population === null)
        return POPULATION_NON_RENSEIGNEE;
    if (population === 'AUTRE' && precision !== null && precision.trim() !== '') {
        return `Autre : ${precision.trim()}`;
    }
    return LIBELLE_POPULATION_COUVERTE[population];
}
/**
 * La précision va avec « Autre », et seulement avec lui. La même phrase pour
 * l'écran et pour l'API. `null` si la saisie tient.
 */
export function refusPopulationCouverte(population, precision) {
    const precise = precision !== null && precision !== undefined && precision.trim() !== '';
    if (population === 'AUTRE' && !precise)
        return 'Précisez quels salariés sont couverts (« Autre »).';
    if (population !== 'AUTRE' && precise) {
        return 'La précision ne va qu’avec « Autre » : choisissez « Autre » ou effacez-la.';
    }
    return null;
}
//# sourceMappingURL=population-couverte.js.map